export const MAX_ATTACHMENT_LIST_SIZE = 10
export const MAX_DEFAULT_ATTACHMENT_SIZE = 26214400
export const MAX_LANDLORD_ATTACHMENT_SIZE = 7340032
